/* Meubelhunter — CRO-laag (Lyfto quick fixes). Vanilla JS, geen afhankelijkheden.
   Onderdelen: uitleg-paneel, USP-ticker, sticky header, klantenservice-status, favorieten,
   winkelwagen 30 dagen bewaren, prijsslider, zoeken met categorieën, kortingscode-toggle. */
(function () {
  'use strict';
  var doc = document;
  function qs(s, r) { return (r || doc).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function ls(k, v) {            // localStorage met try/catch (private mode, geblokkeerd)
    try { if (v === undefined) return localStorage.getItem(k); if (v === null) localStorage.removeItem(k); else localStorage.setItem(k, v); } catch (e) {}
    return null;
  }
  function json(k, fallback) { try { var v = JSON.parse(ls(k) || 'null'); return v == null ? fallback : v; } catch (e) { return fallback; } }
  function on(ev, sel, fn) { doc.addEventListener(ev, function (e) { var t = e.target.closest && e.target.closest(sel); if (t) fn(e, t); }); }
  function ready(fn) { if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', fn); else fn(); }
  function debounce(fn, ms) { var t; return function () { clearTimeout(t); var a = arguments, c = this; t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function setText(el, t) { if (el && el.textContent !== String(t)) el.textContent = t; }   // alleen schrijven bij verschil: anders triggert onze eigen MutationObserver zichzelf
  var isDesktop = function () { return window.innerWidth >= 750; };

  /* ===== Uitleg-paneel (CRO-01/43/44) ===== */
  var sheet, box, sbody, lastTrigger;
  function openSheet(key, trigger) {
    sheet = sheet || qs('[data-cro-sheet]'); if (!sheet) return;
    box = box || qs('[data-cro-sheet-box]', sheet); sbody = sbody || qs('[data-cro-sheet-body]', sheet);
    var tpl = qs('template[data-cro-tpl="' + key + '"]'); if (!tpl) return;
    lastTrigger = trigger;
    sbody.innerHTML = ''; sbody.appendChild(tpl.content.cloneNode(true));
    sheet.classList.add('is-open'); sheet.setAttribute('aria-hidden', 'false');
    doc.body.classList.add('cro-sheet-open');
    placeSheet(trigger);
    box.focus({ preventScroll: true });
  }
  function placeSheet(trigger) {
    if (!box) return;
    if (!isDesktop() || !trigger) { box.style.left = box.style.top = ''; return; }
    var r = trigger.getBoundingClientRect(), w = box.offsetWidth || 360, h = box.offsetHeight || 220;
    var left = Math.min(Math.max(8, r.left + r.width / 2 - w / 2), window.innerWidth - w - 8);
    var top = r.bottom + 8;
    if (top + h > window.innerHeight - 8) top = Math.max(8, r.top - h - 8);
    box.style.left = left + 'px'; box.style.top = top + 'px';
  }
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open'); sheet.setAttribute('aria-hidden', 'true');
    doc.body.classList.remove('cro-sheet-open');
    if (lastTrigger && lastTrigger.focus) { try { lastTrigger.focus({ preventScroll: true }); } catch (e) {} }
  }
  on('click', '[data-cro-sheet-open]', function (e, t) { e.preventDefault(); openSheet(t.getAttribute('data-cro-sheet-open'), t); });
  on('click', '[data-cro-sheet-close]', function (e) { e.preventDefault(); closeSheet(); });
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeSheet(); closeFav(); } });
  window.addEventListener('resize', debounce(function () { if (sheet && sheet.classList.contains('is-open')) placeSheet(lastTrigger); }, 120));

  /* ===== USP-ticker mobiel (CRO-02) ===== */
  function initTicker() {
    var list = qs('[data-cro-usp-list]'); if (!list) return;
    var items = qsa('.cro-usp__li', list), i = 0, timer;
    if (items.length < 2) return;
    function step() {
      if (window.innerWidth >= 1100 || doc.hidden || (sheet && sheet.classList.contains('is-open'))) return;
      items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active');
    }
    timer = setInterval(step, 4200);
  }

  /* ===== Sticky header: USP-balk blijft, header verdwijnt bij omlaag scrollen en komt terug bij omhoog (CRO-02) ===== */
  function initSticky() {
    var usp = qs('[data-cro-usp]'), hdr = qs('.site-header'); if (!usp || !hdr) return;
    function setH() { doc.documentElement.style.setProperty('--cro-usp-h', usp.offsetHeight + 'px'); }
    setH(); window.addEventListener('resize', debounce(setH, 100));
    if (window.ResizeObserver) { try { new ResizeObserver(setH).observe(usp); } catch (e) {} }
    var lastY = window.pageYOffset, ticking = false;
    function locked() {
      var a = doc.activeElement;
      return doc.body.classList.contains('mh-cd-open') || doc.body.classList.contains('cro-sheet-open') ||
        doc.body.classList.contains('cro-favd-open') || (a && hdr.contains(a) && /^(INPUT|SELECT|TEXTAREA)$/.test(a.tagName)) ||
        doc.body.classList.contains('mobile-search-takeover-active') ||
        !!qs('.mh-drawer.is-open, .mh-drawer[aria-hidden="false"]');
    }
    function onScroll() {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () {
        var y = window.pageYOffset, dy = y - lastY;
        if (Math.abs(dy) >= 8) {
          if (y < 120 || dy < 0 || locked()) hdr.classList.remove('cro-hdr--hidden');
          else hdr.classList.add('cro-hdr--hidden');
          lastY = y;
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    hdr.addEventListener('focusin', function () { hdr.classList.remove('cro-hdr--hidden'); });
  }

  /* ===== Klantenservice: nu bereikbaar? (CRO-16/37) — ma t/m vr 10:00-18:00, Europe/Amsterdam ===== */
  var OPEN_MIN = 10 * 60, CLOSE_MIN = 18 * 60;
  function nlNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
      var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
      return { wd: o.weekday, min: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
    } catch (e) { var d = new Date(); return { wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()], min: d.getHours() * 60 + d.getMinutes() }; }
  }
  function serviceState() {
    var n = nlNow(), work = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(n.wd) > -1;
    if (work && n.min >= OPEN_MIN && n.min < CLOSE_MIN) return { open: true, full: 'Nu bereikbaar · tot 18:00', short: 'Nu bereikbaar' };
    if (work && n.min < OPEN_MIN) return { open: false, full: 'Nu gesloten · vandaag weer vanaf 10:00', short: 'Gesloten · vanaf 10:00' };
    if (n.wd === 'Fri' || n.wd === 'Sat' || n.wd === 'Sun') return { open: false, full: 'Nu gesloten · maandag weer vanaf 10:00', short: 'Gesloten · ma vanaf 10:00' };
    return { open: false, full: 'Nu gesloten · morgen weer vanaf 10:00', short: 'Gesloten · morgen 10:00' };
  }
  function updateService() {
    var st = serviceState();
    qsa('[data-cro-service]').forEach(function (el) {
      el.setAttribute('data-cro-open', st.open ? '1' : '0');
      setText(qs('[data-cro-status]', el), el.classList.contains('cro-service--compact') ? st.short : st.full);
      var lv = qs('[data-cro-live]', el); if (lv) lv.classList.toggle('is-open', st.open);
    });
  }

  /* ===== Favorieten zonder account (CRO-24) ===== */
  var FKEY = 'mh_fav';
  function favs() { var a = json(FKEY, []); return Array.isArray(a) ? a : []; }
  function saveFavs(a) { ls(FKEY, JSON.stringify(a.slice(0, 60))); }
  function syncFavs() {
    var a = favs();
    qsa('[data-cro-fav]').forEach(function (b) {
      var on_ = a.indexOf(b.getAttribute('data-cro-fav')) > -1;
      b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
      setText(qs('[data-cro-fav-txt]', b), on_ ? 'Bewaard in favorieten' : 'Bewaar in favorieten');
    });
    qsa('[data-cro-fav-count]').forEach(function (c) { setText(c, a.length ? String(a.length) : ''); c.classList.toggle('is-on', a.length > 0); });
    setText(qs('[data-cro-favd-count]'), a.length ? String(a.length) : '');
  }
  function toggleFav(h) {
    var a = favs(), i = a.indexOf(h);
    if (i > -1) a.splice(i, 1); else a.unshift(h);
    saveFavs(a); syncFavs();
  }
  on('click', '[data-cro-fav]', function (e, b) {
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-cro-fav'), inDrawer = !!b.closest('[data-cro-favd]');
    toggleFav(h);
    if (inDrawer) { var cell = b.closest('.pc-cell'); if (cell) cell.remove(); if (!qs('[data-cro-favd] .pc-cell')) renderFavs(); }
  });
  var favd;
  function openFav() {
    favd = favd || qs('[data-cro-favd]'); if (!favd) return;
    favd.classList.add('is-open'); favd.setAttribute('aria-hidden', 'false'); doc.body.classList.add('cro-favd-open');
    renderFavs();
    var p = qs('.cro-favd__panel', favd); if (p) p.focus({ preventScroll: true });
  }
  function closeFav() {
    if (!favd || !favd.classList.contains('is-open')) return;
    favd.classList.remove('is-open'); favd.setAttribute('aria-hidden', 'true'); doc.body.classList.remove('cro-favd-open');
  }
  on('click', '[data-cro-fav-open]', function (e) { e.preventDefault(); openFav(); });
  on('click', '[data-cro-fav-close]', function (e) { e.preventDefault(); closeFav(); });
  var favToken = 0;
  function renderFavs() {
    var body = qs('[data-cro-favd-body]'); if (!body) return;
    var a = favs(), token = ++favToken;
    if (!a.length) {
      body.innerHTML = '<div class="cro-favd__empty"><svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="#C9C2B4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.4 4.8 6.7 4.8c2 0 3.5 1.1 5.3 3.2 1.8-2.1 3.3-3.2 5.3-3.2 3.3 0 5.200 3.2 4 6.5-1.8 4.6-9.3 9.2-9.3 9.2Z"/></svg><strong>Nog geen favorieten</strong>Tik op het hartje bij een product om het hier te bewaren.<br><a class="cro-favd__btn" href="/collections/all" data-cro-fav-close>Bekijk producten</a></div>';
      syncFavs(); return;
    }
    body.innerHTML = '<div class="cro-favd__grid" data-cro-favd-grid></div>';
    var grid = qs('[data-cro-favd-grid]', body);
    var out = new Array(a.length), done = 0;
    a.forEach(function (h, idx) {
      fetch('/products/' + encodeURIComponent(h) + '?view=card', { headers: { 'Accept': 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return null;
          var d = new DOMParser().parseFromString(html, 'text/html'), cell = d.querySelector('.pc-cell');
          return cell ? cell.outerHTML : null;
        })
        .catch(function () { return null; })
        .then(function (cellHtml) {
          out[idx] = cellHtml; done++;
          if (done < a.length || token !== favToken) return;
          var ok = out.filter(Boolean);
          var keep = a.filter(function (h2, i2) { return !!out[i2]; });        // verwijderde producten opruimen
          if (keep.length !== a.length) saveFavs(keep);
          if (!ok.length) { renderFavs(); return; }
          grid.innerHTML = ok.join(''); syncFavs();
        });
    });
  }

  /* ===== Winkelwagen 30 dagen bewaren + "welkom terug" (CRO-25) ===== */
  var CKEY = 'mh_cart_snap', SNOOZE = 'mh_cart_snooze', DAYS30 = 30 * 864e5;
  var eligible = false;
  function cartJson() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); }); }
  function snapOf(cart) {
    return { ts: Date.now(), co: false, items: cart.items.map(function (i) { return { id: i.variant_id, q: i.quantity, t: i.product_title, v: i.variant_title || '', img: i.image || '', url: i.url }; }) };
  }
  function freshSnap() { var s = json(CKEY, null); return (s && s.items && s.items.length && (Date.now() - s.ts) < DAYS30) ? s : null; }
  function welcomeHtml(s, drawer) {
    var thumbs = s.items.slice(0, 3).map(function (i) { return i.img ? '<img src="' + String(i.img).replace(/(\.[a-z]+)(\?|$)/i, '_80x80$1$2') + '" alt="" width="38" height="38" loading="lazy">' : ''; }).join('');
    var names = s.items.map(function (i) { return i.t; }).slice(0, 2).join(', ') + (s.items.length > 2 ? ' + ' + (s.items.length - 2) + ' meer' : '');
    var days = Math.max(0, Math.floor((Date.now() - s.ts) / 864e5));
    return '<div class="cro-welkom' + (drawer ? ' cro-welkom--drawer' : '') + '" data-cro-welkom role="region" aria-label="Winkelwagen terugzetten">' +
      '<span class="cro-welkom__thumbs">' + thumbs + '</span>' +
      '<span class="cro-welkom__text"><strong>Welkom terug!</strong><span>Je winkelwagen staat nog klaar: ' + names.replace(/</g, '&lt;') + '</span></span>' +
      '<button type="button" class="cro-welkom__btn" data-cro-restore>Zet terug in winkelwagen</button>' +
      (drawer ? '' : '<button type="button" class="cro-welkom__no" data-cro-welkom-no aria-label="Niet meer tonen">✕</button>') + '</div>';
  }
  function showWelcome() {
    var s = freshSnap(); if (!s || !eligible) return;
    var snooze = parseInt(ls(SNOOZE) || '0', 10);
    if (!qs('.cro-welkom:not(.cro-welkom--drawer)') && Date.now() > snooze) {
      var anchor = qs('.wm-strip') || qs('.site-header');
      if (anchor) anchor.insertAdjacentHTML('afterend', welcomeHtml(s, false));
    }
    var empty = qs('[data-cd-content] .mh-cd__empty');
    if (empty && !qs('.cro-welkom--drawer')) empty.insertAdjacentHTML('beforebegin', welcomeHtml(s, true));
  }
  function hideWelcome() { qsa('[data-cro-welkom]').forEach(function (n) { n.remove(); }); }
  on('click', '[data-cro-welkom-no]', function () { ls(SNOOZE, String(Date.now() + 3 * 864e5)); hideWelcome(); });
  on('click', '[data-cro-restore]', function () {
    var s = freshSnap(); if (!s) return;
    eligible = false; hideWelcome();
    if (window.MHCartDrawer && window.MHCartDrawer.addItems) window.MHCartDrawer.addItems(s.items.map(function (i) { return { id: i.id, quantity: i.q }; }));
  });
  on('click', '[data-cd-checkout], a[href="/checkout"], [name="checkout"]', function () {
    var s = json(CKEY, null); if (s) { s.co = true; ls(CKEY, JSON.stringify(s)); }
  });
  function initCart() {
    cartJson().then(function (cart) {
      if (cart.item_count > 0) { ls(CKEY, JSON.stringify(snapOf(cart))); eligible = false; }
      else { eligible = !!freshSnap() && !(json(CKEY, {}).co); showWelcome(); }
    }).catch(function (e) { if (window.console) console.warn('[mh-cro]', e); });
    var host = qs('[data-cd-content]'); if (!host) return;
    var cb = debounce(function () {
      cartJson().then(function (cart) {
        if (cart.item_count > 0) { ls(CKEY, JSON.stringify(snapOf(cart))); eligible = false; hideWelcome(); }
        else {
          if (eligible) showWelcome();          // pagina-load-toestand: drawer toont de terugzet-optie
          else { ls(CKEY, null); hideWelcome(); }  // klant heeft zelf alles verwijderd
        }
      }).catch(function (e) { if (window.console) console.warn('[mh-cro]', e); });
    }, 350);
    new MutationObserver(cb).observe(host, { childList: true, subtree: true });
  }

  /* ===== Prijsfilter met slider (CRO-08) ===== */
  function fmtEuro(n) { return '€' + String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); }
  function initSliders() {
    qsa('.collection-filters__price-range-form:not([data-cro-slider])').forEach(function (form) {
      var max = parseInt(form.getAttribute('data-cro-max'), 10); if (!max || max < 50) return;
      var stp = max > 1500 ? 25 : 10; max = Math.ceil(max / stp) * stp;
      var ins = qsa('input[data-filter-range]', form); if (ins.length < 2) return;
      var fromI = ins[0], toI = ins[1];
      form.setAttribute('data-cro-slider', '');
      var step = max > 1500 ? 25 : 10;
      var v0 = parseFloat(form.getAttribute('data-cro-from')); if (isNaN(v0)) v0 = 0;
      var v1 = parseFloat(form.getAttribute('data-cro-to')); if (isNaN(v1)) v1 = max;
      var wrap = doc.createElement('div'); wrap.className = 'cro-slider';
      wrap.innerHTML =
        '<div class="cro-slider__labels"><span data-lo></span><span data-hi></span></div>' +
        '<div class="cro-slider__track"><div class="cro-slider__rail"></div><div class="cro-slider__fill" data-fill></div>' +
        '<input type="range" min="0" max="' + max + '" step="' + step + '" value="' + v0 + '" aria-label="Minimumprijs" data-r0>' +
        '<input type="range" min="0" max="' + max + '" step="' + step + '" value="' + v1 + '" aria-label="Maximumprijs" data-r1></div>' +
        '<div class="cro-slider__chips" data-chips></div>';
      var anchor = qs('.collection-filters__filter-range', form) || form.firstChild;
      form.insertBefore(wrap, anchor);
      var r0 = qs('[data-r0]', wrap), r1 = qs('[data-r1]', wrap), fill = qs('[data-fill]', wrap), lo = qs('[data-lo]', wrap), hi = qs('[data-hi]', wrap);
      function paint() {
        var a = +r0.value, b = +r1.value, p = function (x) { return 11 + (x / max) * (wrap.querySelector('.cro-slider__track').clientWidth - 22 || 0); };
        fill.style.left = p(a) + 'px'; fill.style.width = Math.max(0, p(b) - p(a)) + 'px';
        lo.textContent = fmtEuro(a); hi.textContent = (b >= max ? fmtEuro(max) + '+' : fmtEuro(b));
        qsa('.cro-slider__chip', wrap).forEach(function (c) { c.classList.toggle('is-on', +c.getAttribute('data-a') === a && +c.getAttribute('data-b') === b); });
      }
      function apply() {
        var a = +r0.value, b = +r1.value;
        fromI.value = a > 0 ? a : ''; toI.value = b < max ? b : '';
        [fromI, toI].forEach(function (i) { i.dispatchEvent(new Event('input', { bubbles: true })); });   // laat Van/Tot-labels meebewegen
        toI.dispatchEvent(new Event('change', { bubbles: true }));
      }
      function keep(which) { var a = +r0.value, b = +r1.value; if (a > b - step) { if (which === 0) r0.value = Math.max(0, b - step); else r1.value = Math.min(max, a + step); } }
      r0.addEventListener('input', function () { keep(0); paint(); }); r1.addEventListener('input', function () { keep(1); paint(); });
      r0.addEventListener('change', apply); r1.addEventListener('change', apply);
      // Snelkeuzes passend bij de prijsrange van deze collectie
      var chips = [], brk = [500, 1000].filter(function (x) { return x < max - 50; });
      if (!brk.length) { if (max > 300) { chips.push([0, 250, 'Tot €250']); chips.push([250, max, '€250+']); } }
      else {
        chips.push([0, brk[0], 'Tot ' + fmtEuro(brk[0])]);
        for (var q = 1; q < brk.length; q++) chips.push([brk[q - 1], brk[q], fmtEuro(brk[q - 1]) + ' - ' + fmtEuro(brk[q])]);
        chips.push([brk[brk.length - 1], max, fmtEuro(brk[brk.length - 1]) + '+']);
      }
      var cw = qs('[data-chips]', wrap);
      chips.forEach(function (c) {
        var b = doc.createElement('button'); b.type = 'button'; b.className = 'cro-slider__chip'; b.textContent = c[2];
        b.setAttribute('data-a', c[0]); b.setAttribute('data-b', c[1]);
        b.addEventListener('click', function () { r0.value = c[0]; r1.value = c[1]; paint(); apply(); });
        cw.appendChild(b);
      });
      paint(); window.addEventListener('resize', debounce(paint, 120));
      setTimeout(paint, 300);
      // de oorspronkelijke Van/Tot-velden blijven werken; houd de slider in de pas bij typen
      [fromI, toI].forEach(function (inp) { inp.addEventListener('input', function () {
        var a = parseFloat(fromI.value), b = parseFloat(toI.value);
        r0.value = isNaN(a) ? 0 : Math.min(a, max); r1.value = isNaN(b) ? max : Math.min(b, max); paint();
      }); });
    });
  }

  /* ===== Zoeken: categorieën bij typfouten en synoniemen (CRO-03) ===== */
  var cats = null;
  var ALIAS = [
    ['eettafel', 'eetkamertafel eettafel eettafels dinertafel keukentafel eethoek eetkamertafels'],
    ['eetkamerstoel', 'eetkamerstoel eetkamerstoelen eetstoel stoel stoelen keukenstoel eetkamerstoeltjes'],
    ['barkruk', 'barkruk barkrukken barstoel barstoelen kruk krukken keukenkruk'],
    ['fauteuil', 'fauteuil fauteuils loungestoel relaxstoel armstoel zetel'],
    ['salon', 'salontafel salontafels koffietafel bijzettafel bijzettafels bijzet'],
    ['poef', 'poef poefs hocker hockers voetenbank'],
    ['tv', 'tvmeubel tvmeubels tvkast tvdressoir televisiemeubel tvstand'],
    ['dressoir', 'dressoir dressoirs buffetkast buffet sideboard'],
    ['wandkast', 'wandkast wandkasten vitrinekast boekenkast'],
    ['nachtkast', 'nachtkast nachtkastje nachtkastjes'],
    ['kasten', 'kast kasten opbergkast'],
    ['verlichting', 'lamp lampen licht verlichting'],
    ['hanglamp', 'hanglamp hanglampen plafondlamp'],
    ['vloerlamp', 'vloerlamp vloerlampen staande lamp'],
    ['tafellamp', 'tafellamp tafellampen bureaulamp nachtlamp'],
    ['garderobe', 'garderobe kapstok kapstokken halmeubel'],
    ['tuin', 'tuinmeubel tuinmeubelen tuinstoel tuintafel buiten'],
    ['woonserie', 'woonserie woonseries serie programma'],
    ['zitmeubel', 'zitmeubel zitmeubelen bank sofa bankstel loungebank hoekbank'],
    ['wijnkast', 'wijnkast wijnrek'],
    ['bartafel', 'bartafel bartafels statafel']
  ];
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function lev(a, b) {
    if (a === b) return 0; var m = a.length, n = b.length; if (!m) return n; if (!n) return m;
    var prev = [], cur = [], i, j; for (j = 0; j <= n; j++) prev[j] = j;
    for (i = 1; i <= m; i++) { cur[0] = i; for (j = 1; j <= n; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1)); var t = prev; prev = cur; cur = t; }
    return prev[n];
  }
  function loadCats() {
    if (cats) return cats;
    cats = []; var el = qs('[data-cro-cats]'); if (!el) return cats;
    var raw; try { raw = JSON.parse(el.textContent); } catch (e) { return cats; }
    var seen = {};
    raw.forEach(function (c) {
      if (!c.t || !c.u || seen[c.u]) return; seen[c.u] = 1;
      var n = norm(c.t), words = n.split(' ').filter(Boolean), extra = [];
      ALIAS.forEach(function (a) { if (n.indexOf(a[0]) > -1) extra = extra.concat(a[1].split(' ')); });
      cats.push({ t: c.t, u: c.u, d: c.d, n: n, joined: n.replace(/ /g, ''), words: words.concat(extra) });
    });
    return cats;
  }
  function score(q, c) {
    var qt = q.split(' ').filter(function (w) { return w.length >= 3; }); if (!qt.length) return 0;
    var total = 0, qj = q.replace(/ /g, '');
    qt.forEach(function (t) {
      var best = 0;
      c.words.concat([c.joined]).forEach(function (w) {
        var s = 0;
        if (w === t) s = 3;
        else if (w.indexOf(t) === 0 && t.length >= 3) s = 2.5;
        else if (t.length >= 5 && t.indexOf(w) === 0 && w.length >= 5) s = 2;
        else { var d = lev(t, w), lim = t.length <= 4 ? 1 : (t.length <= 7 ? 2 : 3); if (d <= lim && Math.abs(t.length - w.length) <= lim) s = 2 - d * 0.35; }
        if (s > best) best = s;
      });
      total += best;
    });
    if (qt.length > 1) { var d2 = lev(qj, c.joined); if (d2 <= 2) total += 2; }
    return total / qt.length;
  }
  function matchCats(query) {
    var q = norm(query); if (q.length < 3) return [];
    return loadCats().map(function (c) { return { c: c, s: score(q, c) }; })
      .filter(function (x) { return x.s >= 1.4; })
      .sort(function (a, b) { return b.s - a.s || a.c.d - b.c.d; })
      .slice(0, 3).map(function (x) { return x.c; });
  }
  function popularCats() {
    var want = ['eettafels', 'eetkamerstoelen', 'tv-meubels', 'salontafels', 'fauteuils', 'dressoirs'];
    var out = []; loadCats().forEach(function (c) { want.forEach(function (w) { if (c.u.indexOf('/collections/' + w) > -1 && !out.some(function (o) { return o.u === c.u; })) out.push(c); }); });
    return out.slice(0, 6);
  }
  function catLinks(list) { return '<ul class="cro-cats__list">' + list.map(function (c) { return '<li><a class="cro-cats__link" href="' + c.u + '">' + c.t.replace(/</g, '&lt;') + ' <span aria-hidden="true">›</span></a></li>'; }).join('') + '</ul>'; }
  var lastQ = '';
  function enhanceFlydown(root) {
    var fly = root.querySelector ? root.querySelector('.search-flydown') : null; if (!fly) return;
    var input = qs('[data-live-search-input]:focus') || qs('[data-live-search-input]'); var q = input ? input.value : ''; if (!q) return;
    var res = qs('[data-live-search-results]', fly); if (!res) return;
    var holder = res.querySelector('.shopify-section > div') || res.querySelector('.shopify-section') || res; if (!holder) return;
    if (holder.querySelector('.cro-cats') && holder.getAttribute('data-cro-q') === q) return;
    qsa('.cro-cats', holder).forEach(function (n) { n.remove(); });
    holder.setAttribute('data-cro-q', q);
    var hits = matchCats(q), none = !!qs('.search-flydown__no-results', holder), html = '';
    if (hits.length) html = '<div class="cro-cats"><h3 class="cro-cats__title">Categorieën</h3>' + catLinks(hits) + '</div>';
    else if (none) { var pop = popularCats(); if (pop.length) html = '<div class="cro-cats"><p class="cro-cats__hint"><strong>Niets gevonden voor “' + q.replace(/</g, '&lt;') + '”.</strong> Bekijk onze populaire categorieën:</p>' + catLinks(pop) + '</div>'; }
    if (html) holder.insertAdjacentHTML('afterbegin', html);
  }
  function initSearch() {
    var mo = new MutationObserver(debounce(function () { qsa('[data-live-search]').forEach(enhanceFlydown); }, 60));
    mo.observe(doc.body, { childList: true, subtree: true });
  }

  /* ===== Kortingscode ingeklapt (CRO-27) ===== */
  on('click', '[data-cd-disc-toggle]', function (e, t) {
    e.preventDefault();
    var w = t.closest('[data-cd-disc]'); if (!w) return; w.classList.add('is-open');
    var i = qs('[data-cd-disc-input]', w); if (i) setTimeout(function () { i.focus(); }, 30);
  });

  /* ===== start ===== */
  ready(function () {
    initTicker(); initSticky(); updateService(); setInterval(updateService, 60000);
    syncFavs(); initCart(); initSliders(); initSearch();
    new MutationObserver(debounce(function () { syncFavs(); updateService(); initSliders(); }, 150)).observe(doc.body, { childList: true, subtree: true });
  });
  // Eerst renderen en daarna pas filters/zoekdata: sommige delen komen via AJAX binnen.
  window.MHCro = { openSheet: openSheet, updateService: updateService, favs: favs, initSliders: initSliders };
})();

/* Zoekveld in het menu = dezelfde zoekfunctie als de header: tikken sluit het menu en opent het zoekscherm
   (categorieën, suggesties, producten). Zonder JS blijft het gewone zoekformulier werken. */
(function () {
  function openHeaderSearch() {
    var drawer = document.querySelector('[data-mh-drawer].is-open');
    var close = drawer && drawer.querySelector('[data-mh-drawer-close]');
    if (close) close.click();
    setTimeout(function () {
      var btn = document.querySelector('[data-mobile-search-button]');
      if (!btn) return;
      btn.click();
      setTimeout(function () { var i = document.querySelector('[data-live-search-input]'); if (i) { try { i.focus(); } catch (e) {} } }, 350);
    }, 260);
  }
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.mh-drawer__search') || !document.querySelector('[data-mobile-search-button]')) return;
    t.blur(); openHeaderSearch();
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('.mh-drawer__search') && document.querySelector('[data-mobile-search-button]')) { e.preventDefault(); openHeaderSearch(); }
  }, true);
})();

/* ===== Vaste filterbalk onderin (mobiel, collectiepagina's) =====
   Eén knop die de bestaande Filters-modal opent. Zichtbaar zolang het productgrid in beeld is
   en er geen paneel/drawer open staat. De WhatsApp-knop (app, shadow DOM) schuift omhoog zodat ze niet botsen. */
(function () {
  var bar, wrapEl, lastShow = null, tick = false;
  var BAR_H = 52, GAP = 12, WA_BASE = 16;
  function build() {
    if (bar || window.innerWidth >= 750) return;
    var f = document.querySelector('[data-productgrid-trigger-filters]'); if (!f) return;
    bar = document.createElement('div'); bar.className = 'cro-fbar'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<button type="button" class="cro-fbar__btn" data-cro-fbar="filters"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h2M10 17h10"/><circle cx="16" cy="7" r="2"/><circle cx="8" cy="17" r="2"/></svg>Filteren</button>';
    document.body.appendChild(bar);
    bar.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cro-fbar]'); if (!b) return;
      var t = document.querySelector('[data-productgrid-trigger-filters]');
      if (t) t.click();
    });
  }
  function overlayOpen() {
    var c = document.body.classList;
    return c.contains('modal-visible') || c.contains('mh-drawer-open') || c.contains('mh-cd-open') || c.contains('cro-sheet-open') || c.contains('mobile-search-takeover-active') || c.contains('cro-favd-open');
  }
  function moveWA(up) {
    var host = document.querySelector('gty-whatsapp-chat-button'), w = host && host.shadowRoot && host.shadowRoot.querySelector('.gty-wacb-wrapper');
    if (!w) return;
    w.style.transition = 'bottom .2s ease';
    w.style.bottom = up ? (WA_BASE + BAR_H + GAP + 4) + 'px' : '';
  }
  function update() {
    tick = false; build(); if (!bar) return;
    var g = document.querySelector('.productgrid--items'), show = false;
    if (g && window.innerWidth < 750) {
      var r = g.getBoundingClientRect(), vh = window.innerHeight;
      show = r.top < vh - 80 && r.bottom > vh * 0.6 && !overlayOpen();
    }
    bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    moveWA(show); lastShow = show;
  }
  function req() { if (!tick) { tick = true; requestAnimationFrame(update); } }
  window.addEventListener('scroll', req, { passive: true });
  window.addEventListener('resize', req);
  new MutationObserver(req).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  setInterval(req, 1500);   // vangt de laat ladende WhatsApp-app en ajax-grids op
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', req); else req();
})();

/* ===== Collectiepagina: dynamisch filteren, sorteren en bladeren zonder paginaverversing (CP-09 / CP-12) =====
   Filterlinks, actieve filters, "Wis alles", paginering, sorteren en de prijsslider halen de nieuwe pagina op (fetch), vervangen alleen het
   productraster, de filterstanden en tellers, en werken de URL bij. Mislukt iets, dan valt het terug op een gewone paginaverversing. */
(function () {
  var doc = document;
  if (!doc.querySelector('[data-productgrid-outer]')) return;
  var ctrl = null, token = 0;
  function kid(el, sel) { for (var i = 0; i < el.children.length; i++) if (el.children[i].matches(sel)) return el.children[i]; return null; }
  function absUrl(h) { try { return new URL(h, location.href); } catch (e) { return null; } }
  function sameList(u) { return u && u.origin === location.origin && u.pathname === location.pathname; }
  function setBusy(on) {
    var g = doc.querySelector('.productgrid--items'); if (g) g.classList.toggle('is-loading', !!on);
    var o = doc.querySelector('[data-productgrid-outer]'); if (o) o.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function scrollToGrid() { var h = doc.querySelector('.cro-chead') || doc.querySelector('.productgrid--wrapper'); if (h) window.scrollTo({ top: h.getBoundingClientRect().top + window.pageYOffset - 70, behavior: 'smooth' }); }
  function total() { var c = doc.querySelector('[data-cro-total]'); return c ? c.getAttribute('data-cro-total') : ''; }
  function updateShow() { qsa('[data-cro-fshow]').forEach(function (b) { var n = total(); b.textContent = n ? 'Toon ' + n + ' producten' : 'Toon resultaten'; }); }
  function qsa(s, r) { return [].slice.call((r || doc).querySelectorAll(s)); }

  function swap(d) {
    var wNow = doc.querySelector('.productgrid--wrapper'), wNew = d.querySelector('.productgrid--wrapper');
    if (!wNow || !wNew) throw new Error('wrapper');
    var nav = kid(wNow, '[data-sticky-utils]'); if (!nav) throw new Error('nav');
    // 1) raster, geen-resultaat, actieve filters, paginering
    ['.productgrid--filters', '.productgrid--items', '.productgrid--no-results', '.pagination--container'].forEach(function (s) { var a = kid(wNow, s); if (a) a.remove(); });
    var frag = doc.createDocumentFragment();
    ['.productgrid--filters', '.productgrid--items', '.productgrid--no-results'].forEach(function (s) { var n = kid(wNew, s); if (n) frag.appendChild(doc.importNode(n, true)); });
    nav.after(frag);
    var pag = kid(wNew, '.pagination--container');
    if (pag) { var pn = doc.importNode(pag, true), desc = kid(wNow, '.collection--description'); if (desc) wNow.insertBefore(pn, desc); else wNow.appendChild(pn); }
    // 2) filterknop, sorteerknop en -lijsten
    var fbNow = doc.querySelector('[data-productgrid-trigger-filters]'), fbNew = d.querySelector('[data-productgrid-trigger-filters]');
    if (fbNow && fbNew) { fbNow.setAttribute('aria-label', fbNew.getAttribute('aria-label') || ''); var ft = fbNow.querySelector('.utils-filter-text'), fn = fbNew.querySelector('.utils-filter-text'); if (ft && fn) ft.textContent = fn.textContent; }
    var sl = doc.querySelector('[data-cro-sort-label]'), sn = d.querySelector('[data-cro-sort-label]'); if (sl && sn) sl.textContent = sn.textContent;
    var ssNow = doc.querySelector('select.utils-sortby-select'), ssNew = d.querySelector('select.utils-sortby-select'); if (ssNow && ssNew) ssNow.value = ssNew.value;
    var smNow = doc.querySelector('[data-productgrid-sort-content]'), smNew = d.querySelector('[data-productgrid-sort-content]'); if (smNow && smNew) smNow.innerHTML = smNew.innerHTML;
    // 3) kop en tellers
    var cNow = doc.querySelector('.cro-chead__count'), cNew = d.querySelector('.cro-chead__count');
    if (cNow && cNew) { cNow.textContent = cNew.textContent; cNow.setAttribute('data-cro-total', cNew.getAttribute('data-cro-total') || ''); cNow.setAttribute('aria-live', 'polite'); }
    // 4) filterpaneel(en): zijbalk en de kopie in het mobiele paneel
    var sbNew = d.querySelector('[data-productgrid-sidebar]');
    if (sbNew) qsa('[data-productgrid-sidebar], .modal--productgrid-sidebar, .modal--productgrid-filters').forEach(function (sb) {
      var mNow = sb.querySelector('.productgrid--filters--mobile'), mNew = sbNew.querySelector('.productgrid--filters--mobile');
      if (mNow && mNew) mNow.innerHTML = mNew.innerHTML;
      else if (mNow && !mNew) mNow.innerHTML = '';
      else if (!mNow && mNew) { var ff = sb.querySelector('.filter-form'); if (ff && ff.parentNode) ff.parentNode.insertBefore(doc.importNode(mNew, true), ff); }
      var gNow = qsa('[data-filter-group-list]', sb), gNew = qsa('[data-filter-group-list]', sbNew);
      if (gNow.length === gNew.length) gNow.forEach(function (ul, i) {
        ul.innerHTML = gNew[i].innerHTML;
        if (ul.getAttribute('data-accordion-state') === 'open') ul.style.setProperty('--menu-open-height', ul.scrollHeight + 'px');
      });
      // prijsslider: alleen opnieuw opbouwen als de prijsfilters buiten de slider om zijn veranderd (bijv. "Wis alles")
      var pf = sb.querySelector('.collection-filters__price-range-form'), pn = sbNew.querySelector('.collection-filters__price-range-form');
      if (pf && pn) {
        var a1 = pf.querySelector('input[name="filter.v.price.gte"]'), a2 = pf.querySelector('input[name="filter.v.price.lte"]');
        var b1 = pn.querySelector('input[name="filter.v.price.gte"]'), b2 = pn.querySelector('input[name="filter.v.price.lte"]');
        if (a1 && a2 && b1 && b2 && (a1.value !== b1.value || a2.value !== b2.value)) {
          a1.value = b1.value; a2.value = b2.value;
          ['data-cro-from', 'data-cro-to', 'data-cro-max'].forEach(function (k) { if (pn.hasAttribute(k)) pf.setAttribute(k, pn.getAttribute(k)); else pf.removeAttribute(k); });
          var old = pf.querySelector('.cro-slider'); if (old) old.remove(); pf.removeAttribute('data-cro-slider');
          if (window.MHCro && window.MHCro.initSliders) window.MHCro.initSliders();
        }
      }
    });
    updateShow();
  }

  function load(url, opts) {
    opts = opts || {};
    var u = absUrl(url); if (!u) { location.href = url; return; }
    if (ctrl) ctrl.abort(); ctrl = new AbortController(); var my = ++token;
    setBusy(true);
    var fu = new URL(u.href), cur = new URL(location.href);
    if (cur.searchParams.get('preview_theme_id') && !fu.searchParams.get('preview_theme_id')) fu.searchParams.set('preview_theme_id', cur.searchParams.get('preview_theme_id'));
    fetch(fu.href, { signal: ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (my !== token) return;
        var d = new DOMParser().parseFromString(html, 'text/html');
        if (!d.querySelector('[data-productgrid-outer]')) throw new Error('geen raster');
        swap(d);
        if (opts.push !== false) history.pushState({ cro: 1 }, '', u.pathname + u.search);
        if (d.title) doc.title = d.title;
        setBusy(false);
        if (opts.scroll) scrollToGrid();
        doc.dispatchEvent(new CustomEvent('cro:grid-updated'));
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; setBusy(false); location.href = u.href; });
  }

  function stop(e) { e.preventDefault(); e.stopPropagation(); if (e.stopImmediatePropagation) e.stopImmediatePropagation(); }
  // klikken op filterlinks, actieve filters, "Wis alles" en paginering
  doc.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || !e.target.closest) return;
    var sb = e.target.closest('[data-productgrid-trigger-sort-button]');
    if (sb) {   // sorteerkeuze in het mobiele paneel
      stop(e); var us = new URL(location.href); us.searchParams.set('sort_by', sb.value); us.searchParams.delete('page'); load(us.href);
      var cl = doc.querySelector('.modal--productgrid-sort [data-modal-close]'); if (cl) cl.click(); return;
    }
    var a = e.target.closest('a[data-filter-input], a.filter-item-clear-all, .active-filter-group a, .pagination--container a[href]');
    if (!a) return;
    var u = absUrl(a.getAttribute('href')); if (!sameList(u)) return;
    stop(e); load(u.href, { scroll: !!a.closest('.pagination--container') });
  }, true);
  // sorteren (select) en prijs (slider/velden): de bestaande handlers van het thema laten we niet meer navigeren
  function onField(e) {
    var t = e.target; if (!t || !t.matches) return;
    if (e.type === 'change' && t.matches('[data-productgrid-trigger-sort]')) {
      stop(e); var u = new URL(location.href); u.searchParams.set('sort_by', t.value); u.searchParams.delete('page'); load(u.href); return;
    }
    if (t.matches('input[data-filter-range]')) {
      stop(e);
      if (e.type !== 'change') return;
      var form = t.closest('form'), u2 = new URL(location.href);
      ['filter.v.price.gte', 'filter.v.price.lte'].forEach(function (n) { var i = form && form.querySelector('input[name="' + n + '"]'); if (i && i.value !== '') u2.searchParams.set(n, i.value); else u2.searchParams.delete(n); });
      u2.searchParams.delete('page'); load(u2.href);
    }
  }
  doc.addEventListener('change', onField, true); doc.addEventListener('input', onField, true);
  window.addEventListener('popstate', function () { load(location.href, { push: false }); });
  // Mobiel filterpaneel: knop "Toon N producten" onderin (sluit het paneel)
  function addShow() {
    var mc = doc.querySelector('.modal--productgrid-sidebar [data-modal-content], .modal--productgrid-filters [data-modal-content]');
    if (!mc || mc.querySelector('[data-cro-fshow]')) return;
    var w = doc.createElement('div'); w.className = 'cro-fshow'; w.innerHTML = '<button type="button" class="cro-fshow__btn" data-cro-fshow></button>';
    mc.appendChild(w); updateShow();
    w.querySelector('button').addEventListener('click', function () { var c = doc.querySelector('.modal--productgrid-sidebar [data-modal-close], .modal--productgrid-filters [data-modal-close]'); if (c) c.click(); });
  }
  new MutationObserver(addShow).observe(doc.body, { childList: true, subtree: true }); addShow();
})();
